query TorahColumnOverlaysQuery($barMitzvah: String!) {
  torahColumnOverlays(barMitzvah: $barMitzvah) {
    id
    name
    firstSefariaId
    lastSefariaId
    skipPrefixWords
    cutTrailingWords
    processingSuccess
    processingMessage
  }
}
